import { createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';

/**
 * TanStack Router設定
 * ファイルベースルーティングによる自動ルート生成
 */
export const router = createRouter({
  routeTree,
  defaultPreload: 'intent', // ホバー時にプリロード
  defaultPreloadStaleTime: 0,
});

/**
 * Router型の登録
 * TypeScriptの型安全性を向上
 */
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
